<nb-card>
  <nb-card-header>
    <nav class="navbar navigation">
      <div class="title-filter">
        <span><nb-icon [icon]="iconos[tipoReporte]" pack="font-awesome"></nb-icon> Informe de {{titulo[tipoReporte]}}</span>


      </div>

      <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
      </button>

    </nav>

  </nb-card-header>

  <nb-card-body>

  </nb-card-body>
</nb-card>
